import { convertPxToRem } from '../../utils/size-manipulation.js';
import 'react';
import { logos } from './logos.js';

const primitives = {
    borderRadii: {
        small: '4px',
        medium: '6px',
        large: '8px',
        xLarge: '16px',
        circular: '50%',
    },
    colors: {
        black: '#000000',
        neutral600: '#0B1F1C',
        neutral500: '#1D2F2C',
        neutral400: '#577671',
        neutral300: 'rgba(11, 31, 28, 0.48)',
        neutral200: 'rgba(11, 31, 28, 0.16)',
        neutral100: '#F7FAFA',
        white: '#FFFFFF',
        arcadiaGreen400: '#0EFF85',
        lushGreen400: '#004037',
        cream400: '#F9F3E8',
        glacier400: '#B7EDED',
        aurora400: '#C4FF45',
        moss400: '#12C167',
        rose400: '#F7A3EC',
        coral400: '#FF6B78',
        cyan400: '#00E3E4',
        red500: '#AD0B1A',
        red400: '#D80E20',
        red100: '#FEF1F2',
        yellow500: '#B25300',
        yellow400: '#E06D07',
        yellow100: '#FFF2E6',
        green500: '#0E753F',
        green400: '#00A34F',
        green100: '#EFFBF5',
    },
    fontFamilies: {
        main: {
            regular: 'DM Sans Regular, sans-serif',
            medium: 'DM Sans Bold, sans-serif',
        },
        monospace: {
            regular: 'Courier Prime Regular, monospace',
            bold: 'Courier Prime Bold, monospace',
        },
    },
    fontSizes: {
        300: convertPxToRem(12),
        400: convertPxToRem(14),
        500: convertPxToRem(16),
        600: convertPxToRem(18),
        700: convertPxToRem(20),
        800: convertPxToRem(24),
        900: convertPxToRem(36),
        1000: convertPxToRem(48),
        1100: convertPxToRem(64),
    },
    lineHeights: {
        small: 1,
        medium: 1.2,
        large: 1.5,
    },
    opacities: {
        high: '100%',
        medium: '80%',
        low: '50%',
    },
    transitionDurations: {
        default: '0.1s',
    },
    iconSizes: {
        minimum: convertPxToRem(16),
        step: convertPxToRem(8),
    },
    logos,
};

export { primitives };
